export const generateMenuItems = (username, quickStartMode) => {
    if (!username) return []
    // if (templateMenuItems) return templateMenuItems
    const dateNow = new Date()
        .toISOString()
        .slice(2, 16)
        .replace(/-/g, '')
        .replace(/:/g, '')

    const newGraphItem = {
        name: 'New Text Graph',
        img: 'app-notes',
        type: 'import',
        category: ['popular', 'analysis', 'all-use-cases'],
        description: 'Visualise any text as a network graph',
        url: `/${username}/graph_${dateNow}/edit`,
    }
    const exploreGPT3 = {
        name: 'LLM Topic Overview',
        img: 'app-kg',
        type: 'aiTopics',
        category: [
            'ideation',
            'analysis',
            'seo',
            'play',
            'import',
            'ai',
            'all-use-cases',
        ],
        description: 'Generate a knowledge graph with AI',
        url: `/${username}/ai_topic_${dateNow}/edit?mode=gpt4`,
    }
    const aiOntologies = {
        name: 'AI Ontologies Graph',
        img: 'app-ontologies',
        type: 'aiOntologies',
        category: [
            'ideation',
            'analysis',
            'play',
            'import',
            'pkm',
            'ai',
            'all-use-cases',
        ],
        description: 'Generate an ontology graph with AI',
        url: `/${username}/ai_onto_${dateNow}/edit`,
    }
    const aiGraphs = {
        name: 'AI Knowledge Graph',
        img: 'app-ai-graph',
        type: 'aiGraphs',
        category: [
            'ideation',
            'analysis',
            'play',
            'import',
            'pkm',
            'ai',
            'all-use-cases',
        ],
        description: 'Generate a knowledge graph with AI',
        url: `/${username}/ai_onto_${dateNow}/edit`,
    }
    const liveIdeationItem = {
        name: 'Live AI Graph Brainstorming',
        img: 'app-insight',
        type: 'aiIdea',
        category: ['ideation', 'notes', 'recommended', 'all-use-cases', 'ai'],
        description: 'Develop ideas using AI and visualization',
        url: `/${username}/ideas_${dateNow}/edit?mode=insight`,
    }
    const analyzeAText = {
        name: 'Analyze a Text',
        type: 'textEditor',
        img: 'app-textanalytics',
        category: [
            'popular',
            'analysis',
            'creative',
            'all-use-cases',
            'text',
            'import',
        ],
        description: 'Add or paste a text to analyze',
        url: `/${username}/article_${dateNow}/notes`,
    }
    const newWritingItem = {
        name: 'Write a Text',
        img: 'app-write',
        category: [
            'popular',
            'creative',
            'recommended',
            'notes',
            'all-use-cases',
        ],
        description: 'Visualise your ideas as a network graph',
        url: `/${username}/text_${dateNow}/edit?editor=1`,
    }
    const analyzeFileItem = {
        name: 'PDF / TXT Files',
        img: 'app-import',
        type: 'textFilesImport',
        category: ['files', 'popular', 'analysis', 'import'],
        description: 'Import a .txt or .pdf file to get an overview',
        url: `/import/files`,
    }

    const exploreTopic = {
        name: 'Explore a Topic',
        img: 'app-explore-topic',
        type: 'aiTopics',
        category: ['ideation', 'popular', 'analysis', 'notes'],
        description: 'Explore a new topic using AI',
        url: `/${username}/topic_${dateNow}/edit?mode=explore`,
    }

    const analyseNewsItem = {
        name: 'News Analysis',
        img: 'app-rss',
        type: 'news',
        category: ['news', 'recommended', 'new', 'marketing', 'all-use-cases'],
        description: 'Current news trends from multiple sources',
        url: `/import/news`,
    }
    const analyseRSSItem = {
        name: 'RSS Feeds',
        type: 'rss',
        img: 'app-rss',
        category: ['rss', 'marketing', 'import', 'news'],
        description: 'Get the main topics from multiple feeds',
        url: `/import/rss`,
    }
    const googleSearchItem = {
        name: 'Google Search',
        img: 'app-google-search',
        type: 'google',
        category: [
            'google',
            'seo',
            'popular',
            'recommended',
            'import',
            'all-use-cases',
        ],
        description: 'Explore the context around a Google query',
        url: `/${username}/google_${dateNow}/google`,
    }
    const surveyResponses = {
        name: 'Qualitative Analysis',
        img: 'app-surveys',
        type: 'qualitativeImport',
        category: ['marketing', 'popular', 'qualitative', 'all-use-cases'],
        description: 'Recurrent themes and gaps in discourse',
        url: `/${username}/surveys_${dateNow}/surveys`,
    }
    const createAMindMap = {
        name: 'Create a Mindmap',
        img: 'app-mindmap',
        type: 'mindmapImport',
        category: [
            'mindmapping',
            'creative',
            'popular',
            'all-use-cases',
            'pkm',
        ],
        description: 'Convert any text into a mindmap',
        url: `/${username}/mindmap_${dateNow}/mindmap`,
    }
    const aiChatGpt = {
        name: 'Live AI Chat Mode',
        img: 'app-chatgpt',
        type: 'aiChat',
        category: [
            'ideation',
            'popular',
            'creative',
            'play',
            'new',
            'ai',
            'all-use-cases',
            'import',
        ],
        description: 'Analyze & develop ideas with live AI graph',
        url: `/${username}/chat_${dateNow}/edit?chat=1`,
    }
    const seoResearch = {
        name: 'SEO',
        img: 'app-seo',
        type: 'seo',
        category: ['seo', 'all-use-cases'],
        description: 'Keyword research for search engines',
        url: `/${username}/seo_${dateNow}/seo`,
    }
    const keywordResearch = {
        name: 'Search Intent Keywords',
        img: 'app-keywords',
        type: 'keywords',
        category: ['seo', 'google', 'import', 'recommended', 'all-use-cases'],
        description: 'Related keywords for any search query',
        url: `/${username}/kwrds_${dateNow}/kwrds`,
    }

    const analyzeSRT = {
        name: 'Audio Transcripts',
        img: 'app-mic',
        type: 'srtFilesImport',
        category: ['files', 'import'],
        description: 'Import an audio transcript SRT/TXT file',
        url: `/import/srt`,
    }

    if (quickStartMode)
        return [
            newGraphItem,
            // analyzeAText,
            googleSearchItem,
            aiChatGpt,
            // liveIdeationItem,
            createAMindMap,
            analyseNewsItem,
            // keywordResearch,
            // surveyResponses,
        ]

    const templateMenuItems = [
        {
            name: 'Text Mining',
            img: 'app-textanalytics',
            type: 'textMining',
            category: ['analysis', 'qualitative', 'all-use-cases'],
            description: 'Topic modeling and visual text analysis',
            url: `/${username}/textmining_${dateNow}/notes`,
        },

        aiGraphs,
        aiOntologies,
        liveIdeationItem,
        exploreGPT3,
        analyzeAText,
        newWritingItem,
        // exploreTopic,

        aiChatGpt,
        createAMindMap,
        {
            name: 'PKM',
            img: 'app-graph',
            type: 'pkmImport',
            category: [
                'notes',
                'pkm',
                'mindmapping',
                'kgs',
                'recommended',
                'all-use-cases',
            ],
            description: 'The quickest editor for knowledge graphs',
            url: `/${username}/pkm_${dateNow}/mindmap`,
        },

        googleSearchItem,
        {
            name: 'X (Twitter)',
            img: 'app-x',
            category: ['twitter', 'analysis', 'import', 'marketing'],
            description: 'Analyze any discourse in Twitter',
            url: `/import/twitter`,
        },

        seoResearch,
        keywordResearch,
        {
            name: 'Demand — Supply',
            img: 'app-niche',
            type: 'niche',
            category: ['marketing', 'recommended', 'all-use-cases'],
            description: "What people search for but don't yet find",
            url: `/${username}/niche_${dateNow}/niche`,
        },
        {
            name: 'Websites & URLs',
            img: 'app-link',
            type: 'urls',
            category: [
                'popular',
                'seo',
                'news',
                'marketing',
                'import',
                'urls',
                'all-use-cases',
            ],
            description: 'Keywords and topics for websites and URLs',
            url: `/import/url`,
        },
        surveyResponses,
        {
            name: 'Customer Reviews',
            img: 'app-reviews',
            type: 'qualitativeImport',
            category: ['seo', 'marketing', 'all-use-cases'],
            description: 'Topical and sentiment analysis',
            url: `/${username}/reviews_${dateNow}/reviews`,
        },
        analyzeFileItem,
        {
            name: 'CSV Spreadsheet',
            img: 'app-csv',
            type: 'csvFileImport',
            category: [
                'files',
                'popular',
                'seo',
                'marketing',
                'analysis',
                'qualitative',
                'import',
            ],
            description: 'Import spreadsheets and .csv files',
            url: `/import/csv`,
        },
        {
            name: 'JSON Files',
            img: 'app-json',
            type: 'jsonFileImport',
            category: [
                'files',
                'popular',
                'seo',
                'marketing',
                'analysis',
                'qualitative',
                'import',
                'new',
                'recommended',
            ],
            description:
                'Extract the main ideas and find gaps in .json(l) files, add filters',
            url: `/import/json`,
            textInput: [
                'files',
                'marketing',
                'popular',
                'allMarketing',
                'allAi',
                'allShortText',
            ],
        },
        {
            name: 'Markdown Files',
            img: 'app-obsidian',
            type: 'mdFilesImport',
            category: ['files', 'popular', 'import'],
            description: 'Visualize your .md files',
            url: `/import/markup`,
        },
        analyzeSRT,
        {
            name: 'Obsidian (MD)',
            img: 'app-obsidian',
            type: 'mdFilesImport',
            category: ['notes', 'pkm', 'popular', 'note-tools', 'import'],
            description: 'Visualize your Obsidian files',
            url: `/import/markup`,
        },
        {
            name: 'LogSeq',
            img: 'app-logseq',
            type: 'mdFilesImport',
            category: ['notes', 'pkm', 'note-tools', 'import', 'all-use-cases'],
            description: 'Visualize your LogSeq files',
            url: `/import/markup`,
        },
        {
            name: 'Roam Research',
            img: 'app-roamresearch',
            type: 'mdFilesImport',
            category: ['notes', 'pkm', 'note-tools', 'import', 'all-use-cases'],
            description: 'Visualize your Roam Research files',
            url: `/import/markup`,
        },
        {
            name: 'Gephi (Gexf) Files',
            img: 'app-gephi',
            type: 'gexfFileImport',
            category: ['files', 'analysis', 'import'],
            description: 'Import Gephi and gexf files',
            url: `/import/gexf`,
        },
        {
            name: 'NetworkX / Graphify',
            img: 'app-graph',
            type: 'networkxFileImport',
            category: ['files', 'analysis', 'import'],
            description: 'Import NetworkX node-link JSON graphs',
            url: `/import/networkx`,
        },
        {
            name: 'Google Scholar',
            img: 'app-scholar',
            type: 'scholar',
            category: ['science', 'google', 'import'],
            description: 'Scientific discourse analysis',
            url: `/import/scholar`,
        },
        {
            name: 'Google Patents Analysis',
            img: 'app-patents',
            type: 'patents',
            category: [
                'science',
                'googlePatents',
                'google',
                'import',
                'marketing',
            ],
            description: 'Analyze Patents search results for your query',
            url: `/import/patents`,
        },
        // {
        //     name: 'Advanced Twitter',
        //     img: 'app-twitter-import',
        //     category: ['twitter'],
        //     description: 'Advanced discourse analysis in twitter',
        //     url: `/import/twitter?context=twitter_${dateNow}`,
        // },
        {
            name: 'Scientific Databases',
            img: 'app-science',
            type: 'science',
            category: ['science', 'import'],
            description: 'Import papers from scientific publications',
            url: `/import/science`,
        },
        // {
        //     name: 'Innovative Trends',
        //     img: 'app-science',
        //     category: ['marketing', 'all-use-cases'],
        //     description: 'Analyze current trends in science',
        //     url: `/import/science`,
        // },
        {
            name: 'Amazon Reviews',
            img: 'app-amazon',
            type: 'amazonReviews',
            category: [
                'marketing',
                'qualitative',
                'amazon',
                'import',
                'all-use-cases',
            ],
            description: 'Analyze product customer reviews',
            url: `/import/amazon`,
        },
        {
            name: 'Amazon Keywords',
            img: 'app-amazon',
            type: 'amazonProducts',
            category: ['seo', 'marketing', 'amazon', 'import', 'all-use-cases'],
            description: 'Analyze keywords for any type of product',
            url: `/import/amazon-keywords`,
        },
        {
            name: 'YouTube Keywords',
            img: 'app-youtube',
            type: 'youtubeKeywords',
            category: [
                'import',
                'marketing',
                'youtube',
                'seo',
                'all-use-cases',
            ],
            description: 'Analyze YouTube search results',
            url: '/import/youtube',
        },
        {
            name: 'YouTube Comments',
            img: 'app-youtube',
            type: 'youtubeComments',
            category: [
                'marketing',
                'qualitative',
                'import',
                'youtube',
                'all-use-cases',
            ],
            description: 'Analyze YouTube video comments',
            url: '/import/youtube-comments',
        },
        {
            name: 'YouTube Subtitles',
            img: 'app-youtube',
            type: 'youtubeSubtitles',
            category: ['analysis', 'youtube', 'import', 'all-use-cases'],
            description: 'Analyze YouTube video subtitles',
            url: '/import/youtube-subtitles',
        },
        {
            name: 'YouTube Channel',
            img: 'app-youtube',
            type: 'youtubeChannel',
            category: [
                'marketing',
                'youtube',
                'seo',
                'import',
                'all-use-cases',
            ],
            description: 'Analyze YouTube channel content',
            url: '/import/youtube-channel',
        },
        {
            name: 'YouTube Playlist',
            img: 'app-youtube',
            type: 'youtubeChannel',
            category: [
                'marketing',
                'youtube',
                'seo',
                'import',
                'all-use-cases',
            ],
            description: 'Analyze YouTube playlist content',
            url: '/import/youtube-channel',
        },
        {
            name: 'Evernote',
            img: 'app-evernote',
            category: ['notes', 'pkm', 'note-tools', 'import', 'all-use-cases'],
            description: 'Visualize your Evernote notes',
            url: `/import/evernote`,
        },
        {
            name: 'Personal Notes',
            img: 'app-write',
            type: 'textEditor',
            category: ['note-tools', 'new', 'import'],
            description: 'Paste your notes from any source',
            url: `/${username}/notes_${dateNow}/notes`,
        },
        analyseNewsItem,
        analyseRSSItem,

        // {
        //     name: 'Social Network',
        //     img: 'app-twitter-social',
        //     category: ['twitter', 'marketing'],
        //     description: 'Analyze a social network on Twitter',
        //     url: `/${username}/twitter_${dateNow}/twitter?currentapp=twitter_social`,
        // },
        {
            name: 'Abstract Graph',
            img: 'app-abstract',
            category: ['play', 'all-use-cases'],
            description: 'Make a sculpture from your ideas',
            url: `/${username}/abstract_${dateNow}/edit?abstract=true`,
        },
        {
            name: 'Music Making',
            img: 'app-midi-color',
            category: ['play', 'all-use-cases'],
            description: 'Play MIDI using the text graphs',
            url: `/${username}/midi_${dateNow}/edit?forcemidi=1`,
        },
        {
            name: 'Speech to graph',
            img: 'app-mic',
            category: ['play', 'all-use-cases'],
            description: 'Dictate, or transcribe a call, into a live graph',
            url: `/${username}/speech_${dateNow}/edit?speech=1`,
        },
    ]
    return templateMenuItems
}
